import type { ItemProperties, POIPageContent } from "@/types";

/**
 * The text of a free-text POI block, or null when the property holds none.
 *
 * Single newlines are doubled: a CMS textarea produces `\n` between paragraphs,
 * which Markdown reads as a soft break, so without this the whole description
 * collapses into one run-on paragraph.
 */
export function descriptionSource(
  properties: ItemProperties,
  options: POIPageContent
): string | null {
  const raw = options.field ? properties[options.field] : undefined;
  if (typeof raw !== "string" || !raw) return null;

  return raw.replace(/(?:\r\n|\r|\n)/g, "\n\n");
}
